module.exports = __webpack_public_path__ + "static/media/roiAction3x.e6260f92.png";